import ContactCard from "@/components/sections/ContactCard";
import { buildContactCards } from "@/components/sections/contact-cards";

export default function Contact({ t }) {
  const cards = buildContactCards(t);

  return (
    <section id="contact" className="py-20 sm:py-32" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 reveal">
          <span className="label-eyebrow">{t.contact.label}</span>
          <h2 className="font-heading text-4xl sm:text-5xl mt-3">{t.contact.title}</h2>
        </div>
        <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5 reveal">
          {cards.map((c) => (
            <ContactCard key={c.tid} {...c} />
          ))}
        </div>
      </div>
    </section>
  );
}
